import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section id="category-grid" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950">
            全网热瓜分类
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">点击分类，深挖你感兴趣的瓜</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, i) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`relative rounded-xl overflow-hidden group transition-all duration-500 ${
                i === 0 ? 'md:col-span-1 md:row-span-2' : ''
              }`}
            >
              <div className={`relative ${i === 0 ? 'aspect-[3/4]' : 'aspect-[3/4]'} w-full`}>
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  title={`911爆料网 ${cat.name}`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <h3 className="text-background-50 font-heading font-bold text-lg md:text-xl">{cat.name}</h3>
                  <p className={`text-background-50/70 text-sm mt-1.5 transition-all duration-500 ${
                    i === 0 ? 'line-clamp-3' : 'line-clamp-2 group-hover:line-clamp-3'
                  }`}>
                    {cat.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}